var _path, _rect, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogodark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.15 32L19.97 11H16.07V14.27H19.46L17.09 12.59L28.13 32H32.15ZM26.39 27.14L26.27 24.08H16.07V27.14H26.39ZM13.79 19.73H3.35V22.94H13.82L13.79 19.73ZM13.49 28.73H1.64V32H17.39V11H2.06V14.27H13.49V28.73Z",
    fill: "#232323"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 11,
    width: 15,
    height: 23,
    fill: "#FCA311"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 39.32C7.14667 39.32 5.6 38.9733 4.16 38.28C2.72 37.5867 1.54667 36.5867 0.64 35.28L2.96 32.56C3.73333 33.6267 4.6 34.4533 5.56 35.04C6.54667 35.6 7.62667 35.88 8.8 35.88C12 35.88 13.6 33.9867 13.6 30.2V14.48H3.48V11H17.56V30C17.56 33.12 16.8133 35.4533 15.32 37C13.8533 38.5467 11.68 39.32 8.8 39.32Z",
    fill: "#232323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 6.825L21.025 3.575H24.075L19.875 6.825H17.625Z",
    fill: "#232323"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogodark);
export default __webpack_public_path__ + "static/media/logodark.0dfc211ced4cc404f776b315d758355d.svg";
export { ForwardRef as ReactComponent };